import { createContext, useContext } from 'react';

export const LangContext = createContext('pl');

export const useLang = () => {
  const lang = useContext(LangContext);
  return lang;
};
